/**
 * Navigation labels live in components/nav-data.ts as English (the sidebar,
 * the command palette and test/routes.test.ts all read them there). Their
 * translations live under `nav.*`, keyed by the label itself:
 * "Chart of Accounts" → "nav.chartOfAccounts".
 */
import type { TFunction } from "./types";

export function navKey(label: string): string {
  const words = label.split(/[^A-Za-z0-9]+/).filter(Boolean);
  return (
    "nav." +
    words
      .map((w, i) =>
        i === 0
          ? w.toLowerCase()
          : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(),
      )
      .join("")
  );
}

/** The label in the active language; an unknown label is shown as written. */
export function navLabel(t: TFunction, label: string): string {
  return t(navKey(label), { defaultValue: label });
}
